/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'

// material-ui
import { Paper, Grid, Typography, withStyles } from '@material-ui/core'

// custom components
import Link from '../Links/Link'

// Query latest article
import useLatestArticle from '../../data/useLatestArticle'

const styles = (theme) => ({
  root: {
    position: 'relative',
    backgroundColor: theme.palette.grey[800],
    color: theme.palette.common.white,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    backgroundImage: 'url(https://source.unsplash.com/daily?summer)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: 'rgba(0,0,0,.3)',
  },
  headline: {
    paddingLeft: theme.spacing(2),
  },
  content: {
    position: 'relative',
    padding: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(6),
      paddingRight: 0,
    },
  },
})

/**
 * Render the latest article / blog
 * @param {Object} props - component properties
 * @param {Object} props.classes - override the injected class names
 * @returns {*}
 * @constructor
 */
function LatestArticle({ classes }) {
  const {
    node: {
      excerpt,
      timeToRead,
      fields: { slug },
      frontmatter: { title, date },
    },
  } = useLatestArticle()

  return (
    <React.Fragment>
      <Typography className={classes.headline} variant="caption">
        Latest article
      </Typography>
      <Link variant="subtitle1" color="inherit" to={slug}>
        <Paper className={classes.root}>
          <div className={classes.overlay} />
          <Grid container>
            <Grid item md={6}>
              <div className={classes.content}>
                <Typography variant="h4" color="inherit" gutterBottom>
                  {title}
                </Typography>
                <Typography component="div" variant="caption" color="inherit">
                  {date}
                </Typography>
                <Typography component="div" variant="caption" color="inherit" gutterBottom>
                  {timeToRead + ' minutes'}
                </Typography>
                <Typography variant="h6" color="inherit" paragraph>
                  {excerpt}
                </Typography>
                <Typography variant="subtitle2" color="secondary">
                  Continue reading...
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </Link>
    </React.Fragment>
  )
}

export default withStyles(styles)(LatestArticle)
